import { render, staticRenderFns } from "./LegislationSection.vue?vue&type=template&id=04e50f2f"
import script from "./LegislationSection.vue?vue&type=script&lang=js"
export * from "./LegislationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports